import { createTripletGlyphIcon } from '../../../utils/createTripletGlyphIcon';

/** Source: `svg-to-react-generator/source-svgs/outline/{S,M,L}/sidebar.svg` */
export const SidebarIcon = createTripletGlyphIcon('SidebarIcon', {
  s: () => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.333 1.33301C14.0692 1.33301 14.6657 1.92993 14.666 2.66602V13.333C14.666 14.0232 14.1419 14.5907 13.4697 14.6592L13.333 14.666H2.66602C1.97608 14.6657 1.40828 14.1417 1.33984 13.4697L1.33301 13.333V2.66602C1.33335 1.93014 1.93014 1.33335 2.66602 1.33301H13.333ZM2.66602 2.43262C2.53765 2.43296 2.43296 2.53765 2.43262 2.66602V13.333C2.43262 13.4617 2.53744 13.5661 2.66602 13.5664H5.51855V2.43262H2.66602ZM6.51855 13.5664H13.333C13.4619 13.5664 13.5664 13.4619 13.5664 13.333V2.66602C13.5661 2.53744 13.4617 2.43262 13.333 2.43262H6.51855V13.5664Z"
        fill="currentColor"
      />
    </svg>
  ),
  m: () => (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15 1.5L15.1533 1.50781C15.9097 1.58461 16.5 2.22334 16.5 3V15L16.4922 15.1533C16.4205 15.8593 15.8593 16.4205 15.1533 16.4922L15 16.5H3C2.22334 16.5 1.58461 15.9097 1.50781 15.1533L1.5 15V3C1.5 2.17157 2.17157 1.5 3 1.5H15ZM3 2.59961C2.77909 2.59961 2.59961 2.77909 2.59961 3V15C2.59961 15.2209 2.77909 15.4004 3 15.4004H6.2334V2.59961H3ZM7.33301 15.4004H15C15.2209 15.4004 15.4004 15.2209 15.4004 15V3C15.4004 2.77909 15.2209 2.59961 15 2.59961H7.33301V15.4004Z"
        fill="currentColor"
      />
    </svg>
  ),
  l: () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22 22H2V2H22V22ZM4 3.5C3.72386 3.5 3.5 3.72386 3.5 4V20C3.5 20.2761 3.72386 20.5 4 20.5H8.27734V3.5H4ZM9.77734 20.5H20.5V3.5H9.77734V20.5Z"
        fill="currentColor"
      />
    </svg>
  ),
});
